import './home.css';
import { Container } from '@mui/material';
//import FilterPanel from '../../components/reporting/filterpanel/FilterPanel';
import ReportGrid from '../../components/reporting/ReportGrid';
//import { CustomerContext } from '../../types/apimodel';
import { DefaultProps } from '../../types/types';

interface ReportingProps extends DefaultProps {
   
}

function Reporting(props: ReportingProps) {

    return (
        <Container maxWidth="lg" >
            {/* <FilterPanel /> */}
            <ReportGrid/>
        </Container>
    )
}

export default Reporting